<div *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
    [banderaColapse]='false' [optionsExportPortal]="false" (devolverAccion)="downloadCsvFormato()">
  </app-lfsa-card>
  <ng-template #carga>
    <div style="position: absolute;right:0;top:0;">
      <button (click)="downloadCsvFormato()" style="width: 43px;
      height: 43px;
      background: #fdca3f;
      border-radius: 100%;
      transition: all .3s ease-in-out;
      box-shadow: 1px 3px 10px #0000004d;
      cursor: pointer;
      font-size: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: lighter;" class="zatras btn btn-success btn-block">
        <span style="margin-top: -10px;">+</span>
      </button>
    </div>
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-12 col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
            [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
            [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-12 col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor1'" [idOpcion]="'idVendedor'"
            [comboBox]="listDeVendedores" formControlName="vendedorId" [control]="formulario.get('vendedorId')"
            [label]="'Vendedor *'" [id]="'vendedorId'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-12 col-md-3">
          <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp;
          <label for="csvInput" class="letrasDanger">{{ titulo }}.csv*</label>
          <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
            accept=".csv" />
        </div>
        <div class="form-group col-12 col-md-3">
          <label for="">&nbsp;</label>
          <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
            class="zatras btn btn-success btn-block">Procesar</button>
        </div>
      </div>
    </form>

    <!-- {{ formulario.value | json }} -->

  </ng-template>

  <app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="''" *ngIf="!mostrarFormulario" [optionsExport]="false">
  </app-lfsa-card>

  <ng-template #enviarTemplate>
    <div class="row form-group">
      <div class="form-group col-md-12" style="display: flex;justify-content: start;align-items: center;">
        <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
          (keyup)="onQuickFilterChanged() " #quickFilter />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style"
          id="{{modulo.agGrid.id}}" [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true"
          [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefsCarteras" [rowSelection]="rowSelection"
          [rowData]="rowDataCarteras" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>
</div>

<div *ngIf="mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'CARGAR DE ARCHIVO'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='false' [optionsExport]="true" (devolverAccion)="downloadDataCsv()"></app-lfsa-card>
  <ng-template #grid>
    <div class="alert alert-danger" role="alert" *ngIf="listaVacia">
      No existen datos para la lista.
    </div>
    <br>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" class="{{modulo.agGrid.class}}" [floatingFilter]="true"
      [frameworkComponents]="frameworkComponents" id="{{modulo.agGrid.id}}" [columnDefs]="columnDefs"
      [rowSelection]="rowSelection" [ngStyle]="modulo.agGrid.style" [paginationPageSize]="modulo.agGrid.paginacion"
      [pagination]="true" [rowData]="rowData">
    </ag-grid-angular>
  </ng-template>
  <div class="row">
    <div class="form-group col-md-6">
      <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="errorData" (click)="guardar()"
        class="btn btn-outline-success btn-block btn-lg">Guardar</button>
    </div>
  </div>
  <br>
  <br>
</div>